define("discourse/plugins/navigation/discourse/components/admin-menu-link-item", ["exports", "discourse/plugins/navigation/discourse/models/menu-link", "discourse/mixins/buffered-content", "discourse/lib/ajax-error", "discourse/lib/computed"], function (_exports, _menuLink, _bufferedContent, _ajaxError, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = Ember.Component.extend((0, _bufferedContent.bufferedProperty)('menuLink'), {
    editing: Ember.computed.empty('menuLink.id'),
    classNameBindings: [':menu-link'],
    cantMoveUp: (0, _computed.propertyEqual)('menuLink', 'firstField'),
    cantMoveDown: (0, _computed.propertyEqual)('menuLink', 'lastField'),
    flags: function () {
      var ret = [];

      if (this.get('menuLink.visible_main')) {
        ret.push(I18n.t('admin.menu_links.enabled.main'));
      }

      if (this.get('menuLink.visible_hamburger_general')) {
        ret.push(I18n.t('admin.menu_links.enabled.hamburger.general'));
      }

      if (this.get('menuLink.visible_hamburger_footer')) {
        ret.push(I18n.t('admin.menu_links.enabled.hamburger.footer'));
      }

      if (this.get('menuLink.visible_brand_general')) {
        ret.push(I18n.t('admin.menu_links.enabled.branding.general'));
      }

      if (this.get('menuLink.visible_brand_icon')) {
        ret.push(I18n.t('admin.menu_links.enabled.branding.icon'));
      }

      return ret.join(', ');
    }.property('menuLink.visible_main', 'menuLink.visible_hamburger_general', 'menuLink.visible_hamburger_footer', 'menuLink.visible_brand_general', 'menuLink.visible_brand_icon'),
    actions: {
      save: function save() {
        var self = this;
        var buffered = this.get('buffered');
        var attrs = buffered.getProperties('name', 'icon', 'url', 'visible_main', 'visible_hamburger_general', 'visible_hamburger_footer', 'visible_brand_general', 'visible_brand_icon');
        this.get('menuLink').save(attrs).then(function () {
          self.set('editing', false);
          self.commitBuffer();
        }).catch(_ajaxError.popupAjaxError);
      },
      moveUp: function moveUp() {
        this.sendAction('moveUpAction', this.get('menuLink'));
      },
      moveDown: function moveDown() {
        this.sendAction('moveDownAction', this.get('menuLink'));
      },
      edit: function edit() {
        this.set('editing', true);
      },
      destroy: function destroy() {
        this.sendAction('destroyAction', this.get('menuLink'));
      },
      cancel: function cancel() {
        var id = this.get('menuLink.id');

        if (Ember.isEmpty(id)) {
          this.sendAction('destroyAction', this.get('menuLink'));
        } else {
          this.rollbackBuffer();
          this.set('editing', false);
        }
      }
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/navigation/discourse/controllers/admin-plugins-navigation", ["exports", "discourse/plugins/navigation/discourse/models/menu-link", "discourse/lib/ajax-error"], function (_exports, _menuLink, _ajaxError) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var MAX_FIELDS = 100;

  var _default = Ember.Controller.extend({
    createDisabled: Em.computed.gte('model.length', MAX_FIELDS),
    arrangedContent: function () {
      return Ember.ArrayProxy.extend(Ember.SortableMixin).create({
        sortProperties: ['position'],
        content: this.get('model')
      });
    }.property('model'),
    actions: {
      createMenu: function createMenu() {
        var m = this.store.createRecord('menu-link', {
          position: 0
        });
        this.get('model').pushObject(m);
      },
      moveUp: function moveUp(f) {
        var idx = this.get('arrangedContent').indexOf(f);

        if (idx) {
          var prev = this.get('arrangedContent').objectAt(idx - 1);
          var prevPos = prev.get('position');
          prev.update({
            position: f.get('position')
          });
          f.update({
            position: prevPos
          });
        }
      },
      moveDown: function moveDown(f) {
        var idx = this.get('arrangedContent').indexOf(f);

        if (idx > -1) {
          var next = this.get('arrangedContent').objectAt(idx + 1);
          var nextPos = next.get('position');
          next.update({
            position: f.get('position')
          });
          f.update({
            position: nextPos
          });
        }
      },
      destroy: function destroy(f) {
        var model = this.get('model'); // Only confirm if we already been saved

        if (f.get('id')) {
          bootbox.confirm(I18n.t("admin.menu_links.delete_confirm"), function (result) {
            if (result) {
              f.destroyRecord().then(function () {
                model.removeObject(f);
              }).catch(_ajaxError.popupAjaxError);
            }
          });
        } else {
          model.removeObject(f);
        }
      }
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/navigation/discourse/initializers/navigation", ["exports", "discourse/lib/plugin-api"], function (_exports, _pluginApi) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    name: 'navigation',
    hamburger_general: [],
    hamburger_footer: [],
    initialize: function initialize(container) {
      var self = this;
      (0, _pluginApi.withPluginApi)('0.4', function (api) {
        api.decorateWidget("hamburger-menu:generalLinks", function () {
          return self.hamburger_general;
        });
        api.decorateWidget("hamburger-menu:footerLinks", function () {
          return self.hamburger_footer;
        });
        var store = container.lookup('store:main');
        store.findAll('menu-link').then(function (rs) {
          rs.content.forEach(function (l) {
            if (l.visible_hamburger_general) {
              self.hamburger_general.push({
                href: l.url,
                rawLabel: l.name
              });
            }

            if (l.visible_hamburger_footer) {
              self.hamburger_footer.push({
                href: l.url,
                rawLabel: l.name
              });
            }
          });
        });
      });
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/navigation/discourse/models/menu-link", ["exports", "discourse/models/rest"], function (_exports, _rest) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var MenuLink = _rest.default.extend();

  var _default = MenuLink;
  _exports.default = _default;
});
define("discourse/plugins/navigation/discourse/navigation-route-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    resource: 'admin.adminPlugins',
    path: 'plugins',
    map: function map() {
      this.route('navigation');
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/navigation/discourse/routes/admin-plugins-navigation", ["exports", "discourse/plugins/navigation/discourse/models/menu-link"], function (_exports, _menuLink) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = Discourse.Route.extend({
    model: function model() {
      return this.store.findAll('menu-link');
    }
  });

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/admin/plugins-navigation"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"ml\"],\"statements\":[[7,\"div\",true],[10,\"class\",\"menu-links\"],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"buttons pull-right\"],[8],[0,\"\\n    \"],[1,[28,\"d-button\",null,[[\"label\",\"action\",\"icon\",\"class\"],[\"admin.menu_links.new\",\"createMenu\",\"plus\",\"btn-primary\"]]],false],[0,\"\\n  \"],[9],[0,\"\\n  \"],[7,\"h2\",true],[8],[1,[28,\"i18n\",[\"admin.menu_links.title\"],null],false],[9],[0,\"\\n  \"],[7,\"br\",true],[8],[9],[0,\"\\n  \"],[7,\"hr\",true],[8],[9],[0,\"\\n\"],[4,\"if\",[[24,[\"model\"]]],null,{\"statements\":[[4,\"each\",[[24,[\"arrangedContent\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"admin-menu-link-item\",null,[[\"menuLink\",\"firstField\",\"lastField\",\"destroyAction\",\"moveUpAction\",\"moveDownAction\"],[[23,1,[]],[24,[\"arrangedContent\",\"firstObject\"]],[24,[\"arrangedContent\",\"lastObject\"]],\"destroy\",\"moveUp\",\"moveDown\"]]],false],[0,\"\\n\"]],\"parameters\":[1]},null]],\"parameters\":[]},null],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/admin/plugins-navigation"}});
Ember.TEMPLATES["javascripts/components/admin-menu-link-item"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"editing\"]]],null,{\"statements\":[[4,\"admin-form-row\",null,[[\"label\"],[\"admin.menu_links.name\"]],{\"statements\":[[0,\"    \"],[1,[28,\"input\",null,[[\"value\",\"class\"],[[24,[\"buffered\",\"name\"]],\"menu-link-name\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[4,\"admin-form-row\",null,[[\"label\"],[\"admin.menu_links.icon\"]],{\"statements\":[[0,\"    \"],[1,[28,\"input\",null,[[\"value\",\"class\"],[[24,[\"buffered\",\"icon\"]],\"menu-link-icon\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[4,\"admin-form-row\",null,[[\"label\"],[\"admin.menu_links.url\"]],{\"statements\":[[0,\"    \"],[1,[28,\"input\",null,[[\"value\",\"class\"],[[24,[\"buffered\",\"url\"]],\"menu-link-url\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[4,\"admin-form-row\",null,[[\"label\"],[\"admin.menu_links.visible\"]],{\"statements\":[[4,\"admin-form-row\",null,[[\"label\"],[\"admin.menu_links.main.menu\"]],{\"statements\":[[0,\"      \"],[7,\"div\",true],[10,\"class\",\"row\"],[8],[0,\"\\n        \"],[7,\"div\",true],[10,\"class\",\"form-element input-area\"],[8],[0,\"\\n          \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"buffered\",\"visible_main\"]]]]],false],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[4,\"admin-form-row\",null,[[\"label\"],[\"admin.menu_links.hamburger.menu\"]],{\"statements\":[[0,\"      \"],[7,\"div\",true],[10,\"class\",\"row\"],[8],[0,\"\\n        \"],[7,\"div\",true],[10,\"class\",\"form-element input-area\"],[8],[0,\"\\n          \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"buffered\",\"visible_hamburger_general\"]]]]],false],[0,\" \"],[1,[28,\"i18n\",[\"admin.menu_links.hamburger.general\"],null],false],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n\\n      \"],[7,\"div\",true],[10,\"class\",\"row\"],[8],[0,\"\\n        \"],[7,\"div\",true],[10,\"class\",\"form-element input-area\"],[8],[0,\"\\n          \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"buffered\",\"visible_hamburger_footer\"]]]]],false],[0,\" \"],[1,[28,\"i18n\",[\"admin.menu_links.hamburger.footer\"],null],false],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[4,\"admin-form-row\",null,[[\"label\"],[\"admin.menu_links.branding.menu\"]],{\"statements\":[[0,\"      \"],[7,\"div\",true],[10,\"class\",\"row\"],[8],[0,\"\\n        \"],[7,\"div\",true],[10,\"class\",\"form-element input-area\"],[8],[0,\"\\n          for \"],[7,\"a\",true],[10,\"target\",\"_blank\"],[10,\"href\",\"https://github.com/vinkas0/discourse-branding\"],[8],[1,[28,\"i18n\",[\"admin.navigation.plugin.branding\"],null],false],[9],[0,\" plugin\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n\\n      \"],[7,\"div\",true],[10,\"class\",\"row\"],[8],[0,\"\\n        \"],[7,\"div\",true],[10,\"class\",\"form-element input-area\"],[8],[0,\"\\n          \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"buffered\",\"visible_brand_general\"]]]]],false],[0,\" \"],[1,[28,\"i18n\",[\"admin.menu_links.branding.general\"],null],false],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n\\n      \"],[7,\"div\",true],[10,\"class\",\"row\"],[8],[0,\"\\n        \"],[7,\"div\",true],[10,\"class\",\"form-element input-area\"],[8],[0,\"\\n          \"],[1,[28,\"input\",null,[[\"type\",\"checked\"],[\"checkbox\",[24,[\"buffered\",\"visible_brand_icon\"]]]]],false],[0,\" \"],[1,[28,\"i18n\",[\"admin.menu_links.branding.icon\"],null],false],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]},null],[0,\"\\n\"],[4,\"admin-form-row\",null,null,{\"statements\":[[0,\"    \"],[1,[28,\"d-button\",null,[[\"action\",\"class\",\"icon\",\"label\"],[\"save\",\"btn-primary\",\"check\",\"admin.menu_links.save\"]]],false],[0,\"\\n    \"],[1,[28,\"d-button\",null,[[\"action\",\"class\",\"icon\",\"label\"],[\"cancel\",\"btn-danger\",\"times\",\"admin.menu_links.cancel\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]},{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"row\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"form-display\"],[8],[0,\"\\n      \"],[7,\"strong\",true],[8],[1,[24,[\"menuLink\",\"name\"]],false],[9],[0,\"\\n    \"],[9],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"form-display\"],[8],[0,\"\\n      \"],[7,\"a\",true],[11,\"href\",[29,[[24,[\"menuLink\",\"url\"]]]]],[10,\"target\",\"_blank\"],[8],[1,[24,[\"menuLink\",\"url\"]],false],[9],[0,\"\\n    \"],[9],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"form-element controls\"],[8],[0,\"\\n      \"],[1,[28,\"d-button\",null,[[\"action\",\"class\",\"icon\",\"label\"],[\"edit\",\"btn-default\",\"pencil\",\"admin.menu_links.edit\"]]],false],[0,\"\\n      \"],[1,[28,\"d-button\",null,[[\"action\",\"class\",\"icon\",\"label\"],[\"destroy\",\"btn-danger\",\"trash-o\",\"admin.menu_links.delete\"]]],false],[0,\"\\n      \"],[1,[28,\"d-button\",null,[[\"action\",\"icon\",\"disabled\"],[\"moveUp\",\"arrow-up\",[24,[\"cantMoveUp\"]]]]],false],[0,\"\\n      \"],[1,[28,\"d-button\",null,[[\"action\",\"icon\",\"disabled\"],[\"moveDown\",\"arrow-down\",[24,[\"cantMoveDown\"]]]]],false],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n  \"],[7,\"small\",true],[10,\"class\",\"row\"],[8],[1,[22,\"flags\"],false],[9],[0,\"\\n\"]],\"parameters\":[]}],[7,\"div\",true],[10,\"class\",\"clearfix\"],[8],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/admin-menu-link-item"}});

